import { render, staticRenderFns } from "./WantIssue.vue?vue&type=template&id=43382b28&scoped=true&"
import script from "./WantIssue.vue?vue&type=script&lang=js&"
export * from "./WantIssue.vue?vue&type=script&lang=js&"
import style0 from "../style.css?vue&type=style&index=0&id=43382b28&prod&scoped=true&lang=css&"
import style1 from "./WantIssue.vue?vue&type=style&index=1&id=43382b28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43382b28",
  null
  
)

export default component.exports